import { ActionType, createAsyncAction } from 'typesafe-actions'
import { UserState } from '../../types'
import { Failure, Request, Success } from './types'

export const fetchUserPermissionAction = createAsyncAction(
  '@user/FETCH_USER_PERMISSION_REQUEST',
  '@user/FETCH_USER_PERMISSION_SUCCESS',
  '@user/FETCH_USER_PERMISSION_FAILURE'
)<Request, Success, Failure>()

const request = (state: UserState): UserState => ({
  ...state,
  isLoadingFetchUserPermission: true,
  isErrorOnLoadingFetchUserPermission: false,
  isSuccessOnLoadingFetchUserPermission: false
})

const success = (state: UserState, action: ActionType<typeof fetchUserPermissionAction.success>): UserState => ({
  ...state,
  isLoadingFetchUserPermission: false,
  isErrorOnLoadingFetchUserPermission: false,
  isSuccessOnLoadingFetchUserPermission: true,
  permission: action.payload.permission
})

const failure = (state: UserState): UserState => ({
  ...state,
  isLoadingFetchUserPermission: false,
  isSuccessOnLoadingFetchUserPermission: false,
  isErrorOnLoadingFetchUserPermission: true
})

export const fetchUserPermissionHandle = { asyncAction: fetchUserPermissionAction, request, success, failure }
